import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./DealsUIHelpers";

const DealsUIContext = createContext();

export function useDealsUIContext() {
  return useContext(DealsUIContext);
}

export const DealsUIConsumer = DealsUIContext.Consumer;

export function DealsUIProvider({ DealsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openEditProductPage: DealsUIEvents?.openEditProductPage,
    openDeleteProductDialog: DealsUIEvents?.openDeleteProductDialog,
    openDeleteContactDialog: DealsUIEvents?.openDeleteContactDialog,
    openFetchContactDialog: DealsUIEvents?.openFetchContactDialog,
    openUpdateContactStatusDialog: DealsUIEvents?.openUpdateContactStatusDialog,
  };

  return (
    <DealsUIContext.Provider value={value}>{children}</DealsUIContext.Provider>
  );
}
